var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"footer"}},[_c('b-container',{staticClass:"footer",attrs:{"fluid":""}},[_c('b-row',{staticClass:"py-3 justify-content-center",attrs:{"id":"footer-box"}},[_c('p',{staticStyle:{"color":"white"}},[_vm._v(" © Copyright 2020 | Developed By: "),_c('span',{staticStyle:{"color":"teal"}},[_c('b',[_vm._v("Me")])])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }